export default "__VITE_ASSET__Cnl$zHN6__"